import { SearchSelectOption } from '../../components/SearchSelect';
import { FLEXIBILITY_OPTIONS } from '../../components/MaterialFieldInputs';
import { CRAFT_ENUM, LIGHT_ENUM, TIP_TYPES } from '../../api/tips';

// 材料域 SearchSelect 的固定候选, 多个页面/弹窗共用 (空值走 placeholder, 不放进候选)

export const SKU_STATUS_OPTS: SearchSelectOption[] = [
    { value: 'on_shelf', label: '在售' },
    { value: 'off_shelf', label: '下架' },
];

export const SKU_HAS_MATERIAL_OPTS: SearchSelectOption[] = [
    { value: 'yes', label: '已绑定材料' },
    { value: 'no', label: '未绑定' },
];

export const YES_NO_OPTS: SearchSelectOption[] = [
    { value: 'yes', label: '是' },
    { value: 'no', label: '否' },
];

// 软硬性: 去掉 "(未选)" 空项, 由 placeholder + clearable 承担
export const FLEXIBILITY_SELECT_OPTS: SearchSelectOption[] = FLEXIBILITY_OPTIONS.filter((o) => o.value);
export const FLEXIBILITY_EMPTY_LABEL = FLEXIBILITY_OPTIONS.find((o) => !o.value)?.label || '';

export const TIP_TYPE_OPTS: SearchSelectOption[] = TIP_TYPES.map((t) => ({ value: t.value, label: t.label }));
export const LIGHT_OPTS: SearchSelectOption[] = LIGHT_ENUM.map(([v, zh]) => ({ value: v, label: zh }));
export const CRAFT_OPTS: SearchSelectOption[] = CRAFT_ENUM.map(([v, zh]) => ({ value: v, label: zh }));
